import {
  REGISTER_ERROR,
  REGISTER_SET_INFO,
  REGISTER_SET_IS_LOADING,
  REGISTER_SET_REGISTER_MODE
} from '../constants';
import { post } from '../Services/http';
import RegisterMode from '../Types/RegisterMode';
import RegisterResponse from '../Types/RegisterResponse';
import { dataLayerGtmSignUp } from '../Services/Gtm.service';
import { CustomerType } from '../Components/Register/types/RegisterProps';

export const performRegister = (registerInfo: any, customerType: CustomerType) => (
  dispatch
) => {
  dispatch(setRegisterFormLoading(true));

  post(`/api/register/${customerType}`, { ...registerInfo })
    .then((res) => res.json())
    .then((response: RegisterResponse) => dispatch(handleRegisterResponse(response, registerInfo.email)))
    .catch((err) => dispatch(handleErrorResponse(err)));
};

export const setRegisterInput = (infoKey: string, value: string) => ({
  type: REGISTER_SET_INFO,
  payload: {
    key: 'registerInfo',
    data: {
      [infoKey]: value,
    }
  }
});

const handleErrorResponse = (err) => (dispatch) => {
  err.response.json().then((data) => dispatch(onError(data.error)));
  dispatch(setRegisterFormLoading(false));
};

const onError = (error?: string) => ({
  type: REGISTER_ERROR,
  payload: {
    error,
  },
});

const setRegisterFormLoading = (isLoading: boolean) => ({
  type: REGISTER_SET_IS_LOADING,
  payload: {
    isLoading,
  },
});

export const setRegisterMode = (registerMode: RegisterMode) => ({
  type: REGISTER_SET_REGISTER_MODE,
  payload: {
    registerMode,
  },
});

const handleRegisterResponse = (response: RegisterResponse, email: string) => (dispatch) => {
  dispatch(onError(response.error));

  if (response.success) {
    if (response.requestToken) {
      localStorage.setItem('requestVerificationToken', response.requestToken);
    }

    if (response.acceptNews) {
      dataLayerGtmSignUp({email: email})
    }

    if (response.myPageUrl && response.myPageUrl != '') {
      window.location.href = response.myPageUrl;
      return;
    }

    dispatch(setRegisterMode(RegisterMode.RegisterSuccess));
    window.scrollTo(0, 0);
  } else {
    dispatch(setRegisterFormLoading(false));
  }
};